__turbopack_context__.v({
  "discountPrice": "ReducedPrice-module__NHtT0G__discountPrice",
  "discountPriceContainer": "ReducedPrice-module__NHtT0G__discountPriceContainer",
  "discountPriceWrapper": "ReducedPrice-module__NHtT0G__discountPriceWrapper",
  "originalPrice": "ReducedPrice-module__NHtT0G__originalPrice",
  "originalPriceText": "ReducedPrice-module__NHtT0G__originalPriceText",
  "price": "ReducedPrice-module__NHtT0G__price",
  "strikedPrice": "ReducedPrice-module__NHtT0G__strikedPrice",
  "vat": "ReducedPrice-module__NHtT0G__vat",
  "vatAdded": "ReducedPrice-module__NHtT0G__vatAdded",
});
